@if (categories?.length > 0 && answerReasons?.length > 0) {
  @if (!!jsonLdFaqs) {
    <span [wcCxJsonLd]="jsonLdFaqs"></span>
  }
  <sd-faq
    [categories]="categories"
    [answerReasons]="answerReasons"
    [hasContactButton]="isContactButton"
    [titleLevelCategory]="pdpType === pdpTypeEnum.ACCESSORY ? 7 : titleLevel"
    [contactLink]="url"
    [iconPos]="iconPos"
    (answerEmitter)="onUsefulClick($event)"
    (categoryOpened)="onCategoryOpened($event)"
  />
}
